<template>
	<video
		data-testid="AtomVideo"
		class="aspect-video"
		:autoplay="autoplay"
		:loop="loop"
		:preload="preload"
		:muted="muted"
		:controls="controls"
		:disable-picture-in-picture="disablePictureInPicture"
		:disable-remote-playback="disableRemotePlayback"
		:x-webkit-airplay="disableRemotePlayback"
		:playsinline="playsInline"
		:webkit-playsinline="playsInline"
		:poster="posterImgSrc"
	>
		<source
			v-if="mp4Src"
			:src="mp4Src"
			type="video/mp4"
			data-testid="AtomVideo-mp4"
		>
		<source
			v-if="webmSrc"
			:src="webmSrc"
			type="video/webm"
			data-testid="AtomVideo-webm"
		>
		<AtomImage
			:src="posterImg.src"
			:alt="posterImg.alt"
			:width="posterImg.width"
			:height="posterImg.height"
			:loading="posterImg.lazy ? 'lazy' : 'eager'"
			fit="cover"
		/>
	</video>
</template>

<script setup lang="ts">
import type { VideoType } from '#base/core/types/VideoType';

const {
	autoplay,
	loop,
	preload = 'none',
	muted,
	controls,
	disablePictureInPicture,
	disableRemotePlayback,
	playsInline,
	posterImg,
} = defineProps<VideoType>();

const img = useImage();
const posterImgSrc = img(posterImg.src, {
	width: posterImg.width,
	height: posterImg.height,
	quality: 40,
});
</script>
